export type MobileAuthProvider = 'google' | 'line';

export const MOBILE_AUTH_BASE_PATH = '/ava-mobile-auth';
export const MOBILE_AUTH_PROVIDERS = ['google', 'line'] as const;
export const MOBILE_AUTH_REDIRECT_PATHS = MOBILE_AUTH_PROVIDERS.map(
  provider => `${MOBILE_AUTH_BASE_PATH}/${provider}`
) as readonly string[];

export const isMobileAuthProvider = (value: string): value is MobileAuthProvider =>
  MOBILE_AUTH_PROVIDERS.includes(value as MobileAuthProvider);

export const resolveMobileAuthProviderFromPath = (pathname: string): MobileAuthProvider | null => {
  const normalizedPathname = pathname.split(/[?#]/, 1)[0] ?? '';
  const expectedNamespace = MOBILE_AUTH_BASE_PATH.replace(/^\//, '');
  const parts = normalizedPathname.split('/').filter(Boolean);
  const provider = parts.length === 2 && parts[0] === expectedNamespace ? parts[1] : null;
  return provider && isMobileAuthProvider(provider) ? provider : null;
};

export const isMobileAuthRedirectPath = (pathname: string): boolean =>
  resolveMobileAuthProviderFromPath(pathname) !== null;

export const buildMobileAuthRedirectUri = (origin: string, provider: MobileAuthProvider): string =>
  `${origin}${MOBILE_AUTH_BASE_PATH}/${provider}`;
